import { render, staticRenderFns } from "./MitPasswordChangePage.vue?vue&type=template&id=a313d928&scoped=true"
import script from "./MitPasswordChangePage.vue?vue&type=script&lang=js"
export * from "./MitPasswordChangePage.vue?vue&type=script&lang=js"
import style0 from "./MitPasswordChangePage.vue?vue&type=style&index=0&id=a313d928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a313d928",
  null
  
)

export default component.exports